module.exports = __webpack_public_path__ + "static/img/8.a7d37b32.png";